import React from "react";

const RoadmapItem = (props) => {
  return (
    <div className="bt-roadmap-item">
      <span className="roadmap-title">{props.item.roadmapTitle}</span>
      <div className="roadmap-content">
        <span className="dot" />
        <h4 className="title">{props.item.title}</h4>

        {props.item.info.map((x, index) => {
          // Check if it's a percentage (starts with + or -)
          const isPercentage = x.startsWith('+') || x.startsWith('-');
          const colorClass = isPercentage 
            ? (x.startsWith('+') ? 'text-success' : 'text-danger')
            : '';
          
          return (
            <span key={index} className={colorClass} style={{ fontWeight: isPercentage ? 'bold' : 'normal' }}>
              {x}
            </span>
          );
        })}
      </div>
    </div>
  );
};

export default RoadmapItem;
